import React, { Component, PureComponent } from 'react';
import NavigationItems from './Components/NavigationItems'
import PageHeader from './Components/PageHeader'
import Footer from './Components/Footer'
import axios from 'axios'
import Base from './Config'
import { Modal, ButtonToolbar, Button } from 'react-bootstrap';
import { TextArea } from 'semantic-ui-react';
import WaveLoading from 'react-loadingg/lib/WaveLoading';
// import 'bootstrap/dist/css/bootstrap.min.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import {
    Link
} from "react-router-dom";

import LocationPicker from 'react-location-picker';
import { geocodeByAddress, getLatLng } from 'react-google-places-autocomplete';

import GooglePlacesAutocomplete from 'react-google-places-autocomplete';

import { CSVLink, CSVDownload } from "react-csv";


export default class componentName extends Component {
    constructor() {
        super()
        this.state = {
            data: [],
            next: null,
            prev: null,
            tenant: false,
            outsider: false,

            loading: true,
            modalShow: false,
            exportModal: false,

            search: "",

            filter: null,

            user_type: "",
        }
    }
    loading = (args) => {
        this.setState({
            loading: args
        })
    }

    componentDidMount() {
        this.loading(true)

        this.fetchAllUsers()
    }

    next = () => {
        // let next = this.state.next;
        // next = next.replace(/^http:\/\//i, 'https://');
        //console.log('next ',this.state.next);
        this.loading(true)
        axios.get(
            this.state.next.replace(/^http:\/\//i, 'https://'),
            //   this.state.next,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            //console.log('Response :',response.data);
            //console.log('Response data.results :',response.data.results);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                loading: false
            })
        })
            .catch(error => {
                //console.log('Error : ',error);
                NotificationManager.error('Error : ', error, 3000);
            })
    }


    prev = () => {
        this.loading(true)
        let prev = this.state.prev;
        prev = prev.replace(/^http:\/\//i, 'https://');
        //console.log('next ',this.state.prev);

        axios.get(
            prev,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            //console.log('Response :',response.data);
            //console.log('Response data.results :',response.data.results);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                loading: false
            })
        })
            .catch(error => {
                //console.log('Error : ',error);
                NotificationManager.error('Error : ', error, 3000);
            })
    }

    fetchAllUsers = () => {
        // this.loading(true)
        // console.log("getting all users ",this.state.user_type);
        let url = Base.url + 'User/?keyword=get_client_profile&is_active=&is_approved=1&search_text=&name_sort_by=&user_type=' + this.state.user_type
        // console.log("url : ",url);
        axios.get(
            url,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            console.log('Response all :', response);
            // console.log('Response all :', response.data.results);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                // filter:false,
                // tenant:false,
                // outsider:false,
                loading: false
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    fetchTenant = () => {
        // this.loading(true)
        this.setState({
            user_type: "T",
            tenant: true,
            outsider: false,
            filter: "Tenants",
            loading: false
        }, () => {
            this.fetchAllUsers()
        })
        // console.log('worked tenant');

        // axios.get(
        //     Base.url + 'User/?keyword=get_client_profile&is_active=&is_approved=&user_type=T',
        //     {
        //         headers: {
        //             'Authorization': 'Token ' + localStorage.getItem('Token'),
        //         }
        //     }
        // ).then(response => {
        //     // console.log('Response all :', response);
        //     // console.log('Response all :', response.data.results);

        //     this.setState({
        //         data: response.data.results,
        //         next: response.data.next,
        //         prev: response.data.previous,
        //         tenant:true,
        //         outsider:false,
        //         filter:"Tenants",
        //         loading:false
        //     })
        // }).catch(error => {
        //     console.log('Error loading quotation count: ', error);
        //     NotificationManager.error('Error : ', error, 3000);
        // })
    }

    fetchOutsiders = () => {
        // this.loading(true)
        this.setState({
            user_type: "O",
            tenant: false,
            outsider: true,
            loading: false,
            filter: 'Outsiders',
        }, () => {
            this.fetchAllUsers()
        })
        // console.log('worked outsider');

        // axios.get(
        //     Base.url + 'User/?keyword=get_client_profile&is_active=&is_approved=&user_type=O',
        //     {
        //         headers: {
        //             'Authorization': 'Token ' + localStorage.getItem('Token'),
        //         }
        //     }
        // ).then(response => {
        //     // console.log('Response all :', response);
        //     // console.log('Response all :', response.data.results);

        //     this.setState({
        //         data: response.data.results,
        //         next: response.data.next,
        //         prev: response.data.previous,



        //         tenant:false,
        //         outsider:true,
        //         loading:false,
        //         filter:'Outsiders',
        //     })
        // }).catch(error => {
        //     console.log('Error loading quotation count: ', error);
        //     NotificationManager.error('Error : ', error, 3000);
        // })
    }
    readAll = () => {
        this.setState({
            filter: false,
            tenant: false,
            outsider: false,
            user_type: "",
        }, () => {
            this.fetchAllUsers()
        })

    }

    createUser = () => {

    }

    // setStatus=(event)=>{
    //     this.setState({
    //       modalShow:true,
    //     })
    // }

    manageUsers = (id, action, reason) => {
        // console.log(action,' : ',id," reason ",reason);

        var bodyFormData = new FormData();
        bodyFormData.set('user_id', id);
        bodyFormData.set('action', action);
        bodyFormData.set('reason', reason);

        axios.patch(
            Base.url + 'User/',
            bodyFormData,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
            .then(response => {
                // console.log('response : ',response);
                if (response.data.Status) {
                    NotificationManager.success(response.data.Message, 'Success : ', 3000)
                } else {
                    console.log(response.data.Message);
                    NotificationManager.error('Error : ', response.data.Error, 3000)

                }
                this.fetchAllUsers()

            })
            .catch(error => {
                NotificationManager.error('Error : ', error, 3000)

            })


    }
    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    searchUser = () => {
        // console.log('worked');

        axios.get(
            Base.url + 'User/?keyword=get_client_profile&is_active=&is_approved=&user_type=&search_text=' + this.state.search,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            // console.log('Response all :', response);
            // console.log('Response all :', response.data.results);

            this.setState({
                data: response.data.results,
                next: response.data.next,
                prev: response.data.previous,
                search: "",
                filter: true,
                tenant: false,
                outsider: false,
                loading: false
            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })
    }

    // deactivateUser=(id)=>{
    //     console.log('Worked deactivte ',id);
    //     // this.fetchAllUsers()
    // }
    handleKeyPress = (e) => {
        if (e.charCode == 13) {
            this.setState({
                filter: true
            }, () => {
                this.searchUser();
            })
        }
    }

    exportData = () => {
        console.log('Clicked');

    }

    render() {



        return (
            <div>


                {/* <NotificationContainer/> */}
                <NavigationItems />
                {/* Main content */}
                <div className="main-content">
                    <PageHeader pageName="Users" />

                    <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8">
                        <div className="container-fluid">
                            <div className="header-body">
                                {/* Card stats */}
                                <div className="row">
                                    <div className="col-xl-3 col-lg-6">
                                        <div className="input-group input-group-alternative mb-3">

                                            <input name="search" onKeyPress={this.handleKeyPress} value={this.state.search} onChange={this.onChange} className="form-control " placeholder="search user" type="text" />
                                            <button type="button" className="btn btn-sm btn-white " onClick={this.searchUser}><i className="fa fa-search" aria-hidden="true"></i></button>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-6">

                                    </div>
                                    <div className="col-xl-3 col-lg-6">

                                    </div>
                                    <div className="col-xl-3 col-lg-6">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Page content */}
                    <div className="container-fluid mt--7">
                        {/* Table */}

                        <div className="row">
                            <div className="col">
                                <div className="card shadow">
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }} className="card-header border-0">
                                        <div style={{ flex: 1, height: '100%' }}>

                                            <h3 className="mb-0">
                                                {this.state.filter && <button className="btn btn-sm bg-translucent-secondary" onClick={this.readAll}>clear filter</button>}
                                                Users
                                                {/* {this.state.filter&&<span className="text-muted text-sm">{' / '+this.state.filter}</span>}  */}
                                            </h3>

                                        </div>
                                        {this.state.loading ? "" :
                                            <div style={{ height: '100%', flex: 1, justifyContent: 'center', display: 'flex', flexDirection: 'row' }}>
                                                <style dangerouslySetInnerHTML={{ __html: "\n                        .test1:hover{\n                          background-color: rgb(241, 241, 241);\n                          /* box-shadow: 0px 1px 2px 0px grey; */\n                        }\n                      " }} />
                                                <div className="test1"
                                                    style={{ boxShadow: '0px 1px 2px 0px grey', padding: 10, display: 'flex', height: '100%', flex: 1, justifyContent: 'center', borderBottomLeftRadius: 10, borderTopLeftRadius: 10, backgroundColor: this.state.tenant ? '#6072E4' : 'white', color: this.state.tenant ? 'white' : 'black' }}
                                                    onClick={this.fetchTenant}
                                                >Tenant</div>
                                                <div className="test1"
                                                    style={{ boxShadow: '0px 1px 2px 0px grey', padding: 10, display: 'flex', flex: 1, justifyContent: 'center', borderBottomRightRadius: 10, borderTopRightRadius: 10, backgroundColor: this.state.outsider ? '#6072E4' : 'white', color: this.state.outsider ? 'white' : 'black' }}
                                                    onClick={this.fetchOutsiders}
                                                >Outsider</div>
                                            </div>
                                        }
                                        <div style={{ height: '100%', flex: 1, justifyContent: 'flex-end', display: 'flex', flexDirection: 'row' }}>
                                            <ButtonToolbar>
                                                {/* <Button variant="primary" onClick={this.modalTrigger}>
                                        Launch vertically centered modal
                                        </Button> */}

                                                {/* <MyVerticallyCenteredModal
                                                    show={this.state.modalShow}
                                                    id={this.state.quotaionid}
                                                    status={this.state.quotaionStatus}


                                                    onHide={() => this.setState({ modalShow: false })}
                                                /> */}
                                            </ButtonToolbar>

                                            {/* <button type="button" className="btn btn-sucess btn-6x" data-target="#myModal" onClick={this.setStatus} >+ New User</button> */}
                                            {this.state.prev == null ? <button disabled={true} className="btn btn-sm btn-primary">Prev</button> : <button className="btn btn-sm btn-primary" onClick={this.prev}>Prev</button>}
                                            {this.state.next == null ? <button disabled={true} className="btn btn-sm btn-primary">Next</button> : <button className="btn btn-sm btn-primary" onClick={this.next}>Next</button>}
                                        </div>
                                    </div>
                                    {this.state.loading ? <WaveLoading /> :
                                        <div className="table-responsive">
                                            <table className="table align-items-center table-flush">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th scope="col">User (En/Ar)</th>
                                                        {/* <th scope="col">Username</th> */}
                                                        {/* <th scope="col">Email</th> */}
                                                        <th scope="col">Type</th>
                                                        <th scope="col">Mobile</th>
                                                        <th scope="col">Action</th>
                                                        <th scope="col">
                                                            {this.state.filter !== "Outsiders" &&
                                                                <button className="btn btn-sm"
                                                                // onClick={this.setStatus} 
                                                                >

                                                                    <ExportModal
                                                                        show={this.state.exportModal}
                                                                        onHide={() => this.setState({ exportModal: false })}
                                                                    />

                                                                    <Link className="text text-black" to="/tenant"><i className="fa fa-plus text-green" /> Create Tenant</Link></button>}
                                                            <button title="Export data" className="btn btn-sm " onClick={() => this.setState({ exportModal: true })}>
                                                                <i className="fas fa-file-export" />
                                                            </button>



                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {this.state.data.map((data, index) =>
                                                        <Items
                                                            Refresh={this.fetchAllUsers}
                                                            ManageUsers={this.manageUsers}

                                                            // Deactivate={this.deactivateUser} 
                                                            key={index} quotation={data}
                                                        />
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                        {/* Footer */}
                        <Footer />
                    </div>
                </div>
            </div>

        );
    }
}

class ExportModal extends PureComponent {
    constructor() {
        super()
        this.state = {
            download: false,
            usertype: "",
            fortenant: false,
            foroutsider: false,
            data: [],

            loading: false,
            name: "zukhrof-users",

            headers: [
                { label: "Index", key: "index" },
                { label: "User Id", key: "id" },
                { label: "Username", key: "username" },
                { label: "Arabic name", key: "arname" },
                { label: "First Name", key: "firstname" },
                { label: "Type", key: "type" },
                { label: "Mobile", key: "mobile" },
                { label: "Email", key: "email" },
            ]
        }
    }
    clearState = () => {
        this.setState({
            download: false,
            usertype: "",
            fortenant: false,
            foroutsider: false,
            data: [],

            loading: false,
            name: "zukhrof-users",
        })
    }

    cancell = () => {
        this.clearState()
        // console.log('worked ',this.props);
        this.props.onHide()
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    generate = () => {
        this.setState({
            loading: true
        })

        let user
        if (this.state.foroutsider) {
            user = "O"
        }
        if (this.state.fortenant) {
            user = "T"
        }
        if (this.state.fortenant && this.state.foroutsider) {
            user = ""
        }
        if (!this.state.fortenant && !this.state.foroutsider) {
            // alert("Please choose user type to export")
            NotificationManager.warning('Please choose user type to export ', "Warning", 10000);
            this.setState({
                loading: false
            })
            return false
        }
        // console.log('User ',user);

        // return false

        axios.get(
            Base.url + 'User/?keyword=get_client_profile&is_active=&is_approved=&user_type=' + user + '&page_wise=false',
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        ).then(response => {
            NotificationManager.info("You can download now", 'File Generated : ', 5000);
            var userdata = []

            // console.log('Response Normal :', response.data);
            response.data.map((item, index) => {
                // console.log('item ',index," : ",item," mob : ",item.mobile);

                let mobile = "mob: "
                mobile = mobile + item.mobile
                userdata.push(
                    {
                        index: index + 1,
                        id: item.id,
                        username: item.user.username,
                        arname: item.ar_name,
                        firstname: item.user.username,
                        type: item.user_type,
                        mobile: mobile.toString(),
                        email: item.user.email
                    },
                )
            })
            this.setState({
                data: userdata,
                loading: false,
                download: true,
            }, () => {
                // console.log('userdata ',userdata);

            })
        }).catch(error => {
            console.log('Error loading quotation count: ', error);
            NotificationManager.error('Error : ', error, 3000);
        })


    }
    render() {

        return (
            <Modal
                {...this.props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >

                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Export User data
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >

                    <table align="center" >
                        <tbody>
                            <tr>
                                <td>
                                    <label className="label label-primary">Please Choose user type</label>
                                </td>
                            </tr>
                            <tr>

                                <td>
                                    <div style={{ display: "flex", flexDirection: "row" }}>
                                        <span onClick={(event) => this.setState({ fortenant: !this.state.fortenant, download: false })} style={{ cursor: "pointer", boxShadow: '0px 1px 2px 0px grey', padding: 10, display: 'flex', height: '100%', flex: 1, justifyContent: 'center', borderBottomLeftRadius: 10, borderTopLeftRadius: 10, backgroundColor: this.state.fortenant ? '#6072E4' : 'white', color: this.state.fortenant ? 'white' : 'black' }} >Tenants</span>
                                        <span onClick={(event) => this.setState({ foroutsider: !this.state.foroutsider, download: false })} style={{ cursor: "pointer", boxShadow: '0px 1px 2px 0px grey', padding: 10, display: 'flex', flex: 1, justifyContent: 'center', borderTopRightRadius: 10, borderBottomRightRadius: 10, backgroundColor: this.state.foroutsider ? '#6072E4' : 'white', color: this.state.foroutsider ? 'white' : 'black' }} >Outsiders</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><label>file Name</label><input name="name" value={this.state.name} onChange={this.onChange} type="text" className="form form-control" placeholder="Name" /></td>

                            </tr>
                        </tbody>
                    </table>
                </Modal.Body>
                <Modal.Footer>


                    {this.state.loading ?
                        <>
                            <Button className="btn btn-danger" onClick={this.cancell}>Cancell</Button>

                            <Button className="btn btn-primary" disabled>Generating </Button>
                        </>
                        :
                        this.state.download ?
                            <>
                                <Button className="btn btn-danger" onClick={this.cancell}>close</Button>

                                <CSVLink
                                    data={this.state.data}
                                    headers={this.state.headers}
                                    filename={this.state.name + ".csv"}
                                    className="btn btn-success"
                                >Download
                                </CSVLink>
                            </>
                            :
                            <>
                                <Button className="btn btn-danger" onClick={this.cancell}>Cancell</Button>
                                <Button className="btn btn-primary" onClick={this.generate}>Generate</Button>
                            </>
                    }





                </Modal.Footer>
            </Modal>
        )
    }
}

class ReasonModal extends PureComponent {
    constructor() {
        super()
        this.state = {
            download: false,
            reason: ""

        }
    }
    clearState = () => {
        this.setState({
            download: false,
            reason: "",
        })
    }

    cancell = () => {
        this.clearState()
        // console.log('worked ',this.props);
        this.props.onHide()
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    generate = () => {
        this.props.deactivate(this.state.reason)
        this.props.onHide()
        this.clearState()


        // this.setState({
        //     loading:true
        // })
    }

    render() {
        // console.log(this.props)
        return (
            <Modal
                // {...this.props}
                show={this.props.show}
                onHide={this.props.onHide}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >

                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Specify a reason for blocking
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <TextArea name="reason" value={this.state.reason} onChange={this.onChange} className="form-control form-control-lg" placeholder="Reason for blocking"></TextArea>
                </Modal.Body>
                <Modal.Footer>


                    {this.state.reason == "" ?
                        <>
                            <Button className="btn btn-danger" onClick={this.cancell}>Cancel</Button>
                            <Button className="btn btn-primary" disabled>Deactivate </Button>
                        </>
                        :
                        <>
                            <Button className="btn btn-danger" onClick={this.cancell}>Cancel</Button>
                            <Button className="btn btn-primary" onClick={this.generate}>Deactivate</Button>
                        </>
                    }





                </Modal.Footer>
            </Modal>
        )
    }
}


class EditModal extends PureComponent {
    constructor() {
        super()
        this.state = {
            download: false,
            reason: "",
            latitude: "",
            longitude: "",
            position: {
                lat: 25.3548,
                lng: 51.1839
            },
        }
    }
    clearState = () => {
        this.setState({
            download: false,
            reason: "",
        })
    }

    cancell = () => {
        this.clearState()
        this.props.onHide()
    }

    // onChange = (e) => {
    //     this.setState({
    //         [e.target.name]: e.target.value
    //     })
    // }
    generate = () => {
        this.props.deactivate(this.state.reason)
        this.props.onHide()
        this.clearState()
    }



    clearState = () => {
        this.setState({
            name: "",
            arname: "",
            username: "",
            mobile: "",
            password: "",
            cpassword: "",
            email: "",
            address: "",
            araddress: "",
            ex_date: "",
            notification_date: "",

            location: "",
            building_no: "",
            door_no: "",
            land_mark: "",
            streat: "",
            latitude: "",
            longitude: "",


        })
    }



    render() {
        // console.log(this.props)
        const data = this.props.data
        // console.log("recieved data ", data)

        return (
            <Modal
                // {...this.props}
                show={this.props.show}
                onHide={this.props.onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    {/* <Modal.Title id="contained-modal-title-vcenter">
                        Specify a reason for blocking
        </Modal.Title> */}
                </Modal.Header>
                <Modal.Body >

                    <div className="container-fluid">
                        <div className="row">

                            <div className="col-xl-12 order-xl-1">
                                <div className="card bg-secondary shadow">
                                    {/* <div className="card-header bg-white border-0">
                                        <div className="row align-items-center">
                                            <div className="col-8">
                                                <h3 className="mb-0">Create Tenant</h3>
                                            </div>
                                            <div className="col-4 text-right">
                                                <button className="btn btn-sm btn-danger" onClick={this.clearState}>Cancel</button>

                                                <button className="btn btn-sm btn-primary" onClick={this.submitForm}>Create</button>
                                            </div>
                                        </div>
                                    </div> */}
                                    <div className="card-body">
                                        <div className="pl-lg-4">
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-control-label" htmlFor="input-username">Name</label>
                                                        <input name="name" value={data.name} onChange={this.props.onchange} type="text" className="form-control form-control-alternative" placeholder="First Name" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-control-label" htmlFor="input-email">Arabic name</label>
                                                        <input name="arname" value={data.arname} onChange={this.props.onchange} placeholder="Arabic name" type="email" id="input-email" className="form-control form-control-alternative" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-control-label" htmlFor="input-username">Username</label>
                                                        <input name="username" value={data.username} onChange={this.props.onchange} type="text" className="form-control form-control-alternative" placeholder="Username" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="col-md-6">
                                                        <base-input placeholder="name@example.com"></base-input>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <base-input placeholder="Disabled" disabled></base-input>
                                                    </div>

                                                    <div className="form-group">
                                                        <label className="form-control-label" htmlFor="input-email">Mobile</label>
                                                        <table>
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan="1">
                                                                        <input disabled name="countrycode" value={data.countrycode} onChange={this.props.onchange} size="5" type="text" className="form-control form-control-alternative" />
                                                                    </td>
                                                                    <td colSpan="3">
                                                                        <input name="mobile" value={data.mobile} onChange={this.props.onchange} size="30" type="text" placeholder="Mobile Numer" className="form-control form-control-alternative" />
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-control-label" htmlFor="input-username">Password</label>
                                                        <input name="password" value={data.password} onChange={this.props.onchange} type="password" className="form-control form-control-alternative" placeholder="Password" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-control-label" htmlFor="input-email">Confirm Password</label>
                                                        <input name="cpassword" value={data.cpassword} onChange={this.props.onchange} placeholder="Confirm Password" type="password" className="form-control form-control-alternative" />
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-control-label" htmlFor="input-username" title="Date of user leaving">User leaving date</label>
                                                        <input className="form-control" type="date" name="ex_date" value={data.ex_date} onChange={this.props.onchange} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-control-label" htmlFor="input-email" title="Email will be send to admin before leaving this user">Notify admin on</label>
                                                        <input className="form-control" type="date" name="notification_date" value={data.notification_date} onChange={this.props.onchange} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-control-label" htmlFor="input-email">Email address</label>
                                                        <input name="email" value={data.email} onChange={this.props.onchange} placeholder="Email address" className="form-control form-control-alternative" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-control-label" htmlFor="input-username">Location</label>
                                                        <input name="location" value={data.location} onChange={this.props.onchange} placeholder="Location" type="text" className="form-control form-control-alternative" />
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-control-label" htmlFor="input-username">Building Number</label>
                                                        <input name="building_no" value={data.building_no} onChange={this.props.onchange} placeholder="Building number" type="text" className="form-control form-control-alternative" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-control-label" htmlFor="input-email">Door Number</label>
                                                        <input name="door_no" value={data.door_no} onChange={this.props.onchange} placeholder="Door number" type="text" className="form-control form-control-alternative" />
                                                    </div>
                                                </div>
                                            </div>


                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-control-label" htmlFor="input-username">Landmark</label>
                                                        <input name="land_mark" value={data.land_mark} onChange={this.props.onchange} placeholder="Landmark" type="text" className="form-control form-control-alternative" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-control-label" htmlFor="input-email">Street</label>
                                                        <input name="streat" value={data.streat} onChange={this.props.onchange} placeholder="Street" type="text" className="form-control form-control-alternative" />
                                                    </div>
                                                </div>
                                            </div>
                                            <br />

                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-control-label" htmlFor="input-username">Latitude</label>
                                                        <input name="latitude" value={data.latitude} onChange={this.props.onchange} placeholder="Latitude" type="text" className="form-control form-control-alternative" />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6">
                                                    <div className="form-group">
                                                        <label className="form-control-label" htmlFor="input-email">Longitude</label>
                                                        <input name="longitude" value={data.longitude} onChange={this.props.onchange} placeholder="Longitude" type="text" className="form-control form-control-alternative" />
                                                    </div>
                                                </div>
                                            </div>


                                            <div>
                                                <GooglePlacesAutocomplete
                                                    onSelect={(val) => this.props.getLatLng(val)}
                                                    autocompletionRequest={{
                                                        location: "",
                                                        componentRestrictions: {
                                                            country: ['qa'],
                                                        }
                                                    }}
                                                />

                                                {data.latitude && data.longitude ? <LocationPicker
                                                    containerElement={<div style={{ height: '50%' }} />}
                                                    mapElement={<div style={{ height: '400px' }} />}
                                                    defaultPosition={{ lat: parseFloat(data.latitude), lng: parseFloat(data.longitude) }}
                                                    onChange={this.props.handleLocationChange}
                                                /> : "No location selected"}
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">

                                                </div>
                                                <div className="col-6 text-right mt-2">
                                                    <button className="btn btn-lg btn-danger" onClick={this.props.clearState}>Cancel</button>
                                                    <button className="btn btn-lg btn-primary" onClick={this.props.edit}>Save</button>
                                                </div>
                                            </div>
                                            <div className="row">

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>
                        {/* <Footer /> */}
                    </div>

                </Modal.Body>
                {/* <Modal.Footer>
                    {this.state.reason == "" ?
                        <>
                            <Button className="btn btn-danger" onClick={this.cancell}>Cancel</Button>
                            <Button className="btn btn-primary" disabled>Deactivate </Button>
                        </>
                        :
                        <>
                            <Button className="btn btn-danger" onClick={this.cancell}>Cancel</Button>
                            <Button className="btn btn-primary" onClick={this.generate}>Deactivate</Button>
                        </>
                    }
                </Modal.Footer> */}
            </Modal>
        )
    }
}

// class MyVerticallyCenteredModal extends React.Component {
//     constructor() {
//         super()
//         this.state = {
//             name: "",
//             arname: "",
//             username: "",
//             mobile: "",
//             password: "",
//             cpassword: "",
//             email: "",
//             address: "",
//             araddress: "",

//             building_no: "",
//             doorno: "",
//             id: "",
//         }
//     }
//     clearState = () => {
//         this.setState({
//             name: "",
//             arname: "",
//             username: "",
//             mobile: "",
//             password: "",
//             cpassword: "",
//             email: "",
//             address: "",
//             araddress: "",

//             building_no: "",
//             doorno: "",
//             id: "",
//         })
//     }

//     submitForm = () => {
//         // console.log('worked ',this.props);
//         // console.log('state ',this.state);

//         if (this.state.cpassword === this.state.password) {


//             var bodyFormData = new FormData();
//             bodyFormData.set('name', this.state.name);
//             bodyFormData.set('name_in_arabic', this.state.arname);
//             bodyFormData.set('username', this.state.username);
//             bodyFormData.set('mobile', this.state.mobile);
//             bodyFormData.set('password', this.state.password);
//             bodyFormData.set('user_type', 'T');
//             bodyFormData.set('email', this.state.email);

//             axios.post(
//                 Base.url + 'User/',
//                 bodyFormData,
//                 {
//                     headers: {
//                         'Authorization': 'Token ' + localStorage.getItem('Token'),
//                     }
//                 }
//             )
//                 .then(response => {
//                     // console.log('response : ',response);
//                     // console.log('response : ',response.data.id);
//                     if (response.data.Status) {

//                         // NotificationManager.success( 'response.data.Message','Success : ',3000)

//                         var bodyFormDataAddress = new FormData();
//                         bodyFormDataAddress.set('building_no', this.state.building_no);
//                         bodyFormDataAddress.set('door_no', this.state.doorno);
//                         bodyFormDataAddress.set('tenant_id', response.data.id);

//                         axios.post(
//                             Base.url + 'Address/',
//                             bodyFormDataAddress,
//                             {
//                                 headers: {
//                                     'Authorization': 'Token ' + localStorage.getItem('Token'),
//                                 }
//                             }
//                         )
//                             .then(response => {
//                                 // console.log('response : ',response);
//                                 if (response.data.Status) {
//                                     // console.log("True ",response);

//                                     NotificationManager.success(response.data.Message.Message, 'Success : ', 3000)
//                                     this.clearState()
//                                     this.props.onHide()
//                                     // this.props.Refresh()
//                                 } else {
//                                     // console.log("false ",response);
//                                     NotificationManager.error('Error : ', response.data.Error, 3000)
//                                 }
//                             })
//                             .catch(error => {
//                                 console.log(error);
//                             })

//                         // this.clearState()
//                         // this.props.onHide()
//                         // this.props.Refresh()
//                     } else {
//                         console.log(response.data.Message);
//                         NotificationManager.error(response.data.Message, response.data.Error, 3000)
//                     }
//                 })
//                 .catch(error => {
//                     console.log(error);
//                 })
//         }
//         else {

//             NotificationManager.info('Info message', 'Close after 2000ms', 3000)
//         }
//     }

//     onChange = (e) => {
//         this.setState({
//             [e.target.name]: e.target.value
//         })
//     }

//     render() {
//         // console.log('props ',this.props);

//         // const {props} = this.props

//         return (
//             <Modal
//                 {...this.props}
//                 size="md"
//                 aria-labelledby="contained-modal-title-vcenter"
//                 centered
//             >

//                 <Modal.Header closeButton>
//                     <Modal.Title id="contained-modal-title-vcenter">
//                         Create Tenant
//         </Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body >
//                     <table align="center" >
//                         <tr>
//                             <td><label>Name</label><input name="name" value={this.state.name} onChange={this.onChange} type="text" className="form form-control" placeholder="Name" /></td>
//                             <td><label>Arabic Name</label><input name="arname" value={this.state.arname} onChange={this.onChange} type="text" className="form form-control" placeholder="Arabic Name" /></td>
//                         </tr>
//                         <tr>
//                             <td><label>Username</label><input name="username" value={this.state.username} onChange={this.onChange} type="text" className="form form-control" placeholder="Username" /></td>
//                             <td><label>Mobile</label><input value={this.state.mobile} onChange={this.onChange} name="mobile" type="text" className="form form-control" placeholder="Mobile" /></td>
//                         </tr>
//                         <tr>
//                             <td><label>Password</label><input name="password" value={this.state.password} onChange={this.onChange} type="password" className="form form-control" placeholder="Password" /></td>
//                             <td><label>Confirm Password</label><input name="cpassword" value={this.state.cpassword} onChange={this.onChange} type="password" className="form form-control" placeholder="Confirm Password" /></td>
//                         </tr>
//                         <tr>
//                             <td colSpan='2'><label>Email</label><input name="email" value={this.state.email} onChange={this.onChange} type="text" className="form form-control" placeholder="Email" /></td>
//                         </tr>
//                         <tr>
//                             <td><label>Building number</label><input name="building_no" value={this.state.building_no} onChange={this.onChange} type="text" className="form form-control" placeholder="Building number" /></td>
//                             <td><label>Door number</label><input name="doorno" value={this.state.doorno} onChange={this.onChange} type="text" className="form form-control" placeholder="Door number" /></td>
//                         </tr>
//                         <tr>
//                             <td></td>
//                             <td></td>
//                         </tr>
//                     </table>
//                 </Modal.Body>
//                 <Modal.Footer>
//                     <Button onClick={this.submitForm}>Submit</Button>
//                 </Modal.Footer>
//             </Modal>
//         )
//     }
// }

class Items extends PureComponent {
    constructor() {
        super()
        this.state = {
            open: false,
            reasonmodal: false,
            editModal: false,

            id: '',
            name: "",
            arname: "",
            username: "",
            mobile: "",
            password: "",
            cpassword: "",
            email: "",
            address: "",
            araddress: "",
            ex_date: "",
            notification_date: "",
            countrycode: "+974",

            location: "",
            building_no: "",
            door_no: "",
            land_mark: "",
            streat: "",
            latitude: "",
            longitude: "",
            place: "",

            // place: "Kala Pattar Ascent Trail, Khumjung 56000, Nepal",
            position: {
                lat: 25.3548,
                lng: 51.1839
            },
            API_KEY: "",


        }
    }

    editSave = () => {

        // console.log('data ',this.state);
        // return false

        // console.log('worked ',this.props);
        // console.log('data : ',this.state);
        // return false
        // console.log('state ',this.state);
        if (this.state.name == "") {
            NotificationManager.warning("Required", " Name", 10000)
            return false
        }
        if (this.state.arname == "") {
            NotificationManager.warning("Required", " Arabic name", 10000)
            return false
        }
        if (this.state.username == "") {
            NotificationManager.warning("Required", " Username", 10000)
            return false
        }
        if (this.state.mobile == "") {
            NotificationManager.warning("Required", " Mobile", 10000)
            return false
        }
        // if (this.state.password == "") {
        //     NotificationManager.warning("Required", "Password", 10000)
        //     return false
        // }
        // if (this.state.cpassword == "") {
        //     NotificationManager.warning("Required", " Confirm Password", 10000)
        //     return false
        // }

        if (this.state.email == "") {
            NotificationManager.warning("Required", " Email address", 10000)
            return false
        }
        if (this.state.ex_date == "") {
            NotificationManager.warning("Required", " User leaving date", 10000)
            return false
        }
        if (this.state.notification_date == "") {
            NotificationManager.warning("Required", " Notifiy admin on", 10000)
            return false
        }
        if (!(this.state.password == this.state.cpassword)) {
            NotificationManager.info("Invalid password", " Password do not match", 10000)
            return false
        }

        if (this.state.cpassword === this.state.password) {
            var bodyFormData = new FormData();
            bodyFormData.append('tenant_id', this.state.id);

            // bodyFormData.append('mobile', this.state.countrycode + this.state.mobile);
            // bodyFormData.append('user_type', 'T');
            bodyFormData.append('email', this.state.email);
            bodyFormData.append('ex_date', this.state.ex_date + " 00:00:00");

            bodyFormData.append('username', this.state.username);
            bodyFormData.append('first_name', this.state.name);
            bodyFormData.append('name_in_arabic', this.state.arname);
            bodyFormData.append('mobile', this.state.mobile);

            if (this.state.password) {
                console.log("password changing");
                bodyFormData.append('password', this.state.password);
            }

            bodyFormData.append('location', this.state.location);
            bodyFormData.append('building_no', this.state.building_no);
            bodyFormData.append('door_no', this.state.door_no);
            bodyFormData.append('land_mark', this.state.land_mark);
            bodyFormData.append('streat', this.state.streat);
            bodyFormData.append('latitude', this.state.latitude);
            bodyFormData.append('longitude', this.state.longitude);
            bodyFormData.append('notification_date', this.state.notification_date + " 00:00:00");


            axios.put(
                Base.url + 'UserAdditional/',
                bodyFormData,
                {
                    headers: {
                        'Authorization': 'Token ' + localStorage.getItem('Token'),
                    }
                }
            )
                .then(response => {
                    // console.log('response : ',response);
                    // console.log('response : ',response.data.id);
                    if (response.data.Status) {
                        // NotificationManager.success( 'response.data.Message','Success : ',3000)
                        NotificationManager.success("User updated", 'Success : ', 3000)
                        this.clearState()
                        this.props.Refresh()
                    } else {
                        // console.log("false ",response);
                        NotificationManager.error('Error : ', response.data.Error, 3000)
                    }
                })
                .catch(error => {
                    console.log(error);
                    // NotificationManager.error(response.data.Message, response.data.Error, 3000)
                })
        }
        else {

            NotificationManager.info('Info ', 'Password donot match', 3000)
        }


    }

    handleLocationChange({ position, place, places }) {
        console.log('possition ', position);
        console.log('place ', place);
        console.log('places ', places);

        // Set new location
        this.setState({ position, place, latitude: position.lat, longitude: position.lng });
    }

    clearState = () => {
        this.setState({
            editModal: false,

            name: "",
            arname: "",
            username: "",
            mobile: "",
            password: "",
            cpassword: "",
            email: "",
            address: "",
            araddress: "",
            ex_date: "",
            notification_date: "",

            location: "",
            building_no: "",
            door_no: "",
            land_mark: "",
            streat: "",
            latitude: "",
            longitude: "",


        })
    }

    toggle() {
        this.setState({
            open: !this.state.open
        });
    }
    callActivateParentFunction = () => {
        // console.log('id ',this.props.quotation.id);
        this.props.ManageUsers(this.props.quotation.id, 'actv')
    }

    callDeactivateParentFunction = (reason) => {
        // console.log('id ',this.props.quotation.id);
        // console.log("dact reason ",reason)
        this.props.ManageUsers(this.props.quotation.id, 'dactv', reason)
    }

    edit = (data) => {

        // console.log("Edit user data", data);
        this.setState({
            editModal: true,

            id: data.id,
            name: data.user.first_name,
            arname: data.ar_name,
            username: data.user.username,
            mobile: data.mobile,
            password: "",
            cpassword: "",
            email: data.user.email,
            // address: data.address[0].,
            // araddress: data.araddress,
            ex_date: data.ex_date ? data.ex_date.slice(0, 10) : "",
            notification_date: data.notification_date ? data.notification_date.slice(0, 10) : "",

            location: data.address[0]?.location,
            building_no: data.address[0]?.building_no,
            door_no: data.address[0]?.door_no,
            land_mark: data.address[0]?.land_mark,
            streat: data.streat,
            latitude: data.address[0]?.latitude,
            longitude: data.address[0]?.longitude,
        })
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    handleLocationChange = ({ position, place, places }) => {
        // console.log('possition ', position);
        // console.log('position.lat ', position.lat);
        // console.log('position.lng ', position.lng);

        // Set new location
        this.setState({ latitude: position.lat, longitude: position.lng });
    }

    getLatLng = (name) => {
        geocodeByAddress(name.description)
            .then(results => getLatLng(results[0]))
            .then(({ lat, lng }) => {
                console.log('Successfully got latitude and longitude', { lat, lng })
                this.setState({
                    latitude: lat,
                    longitude: lng
                })
            }
            );
    }


    render() {
        // const {Activate,Deactivate} =this.props
        let data = this.props.quotation
        // console.log('data ',data);
        const date = new Date(data.ex_date)

        return (
            <>
                <ReasonModal
                    show={this.state.reasonmodal}
                    onHide={() => this.setState({ reasonmodal: false })}
                    deactivate={this.callDeactivateParentFunction}
                />
                <EditModal
                    show={this.state.editModal}
                    onHide={() => this.setState({ editModal: false })}
                    data={this.state}
                    onchange={this.onChange}
                    handleLocationChange={this.handleLocationChange}
                    getLatLng={this.getLatLng}
                    edit={this.editSave}
                />

                <tr>

                    <th scope="row">
                        <small>First name</small><br /><label>{data.user.first_name}</label>
                        <br />
                        <small> اسم المستخدم </small><br />
                        <label>{data.ar_name}</label>
                        <br />
                        <small>Email</small><br /> {data.user.email ? data.user.email : 'No email'}
                        <br />
                        {data.user_type == 'T' &&
                            <>
                                <label >
                                    Agreement Date : {date.toDateString()}
                                </label>
                            </>
                        }


                    </th>
                    <td>
                        {data.user_type == 'O' ?
                            'Outsider'
                            :
                            "Tenant"
                        }

                    </td>
                    <td>{data.mobile}</td>
                    <td>
                        {data.is_active ?
                            // <button type="button" style={{ width: 90 }} className="btn btn-sucess btn-sm text-red" onClick={this.callDeactivateParentFunction}>Deactivate</button>
                            <button type="button" style={{ width: 90 }} className="btn btn-sucess btn-sm text-red" onClick={() => this.setState({ reasonmodal: true })}>Deactivate</button>

                            :
                            <button type="button" style={{ width: 90 }} className="btn btn-sucess btn-sm text-green" onClick={this.callActivateParentFunction} >Activate</button>

                        }
                    </td>
                    <td>{data.address.length > 0 ?
                        <div className="btn btn-sm" onClick={this.toggle.bind(this)}>{this.state.open ? <i className="fa fa-close text-red" ></i> : <i className="fa fa-info text-blue" ></i>}</div>
                        :
                        <div disabled className=" btn-sm"><i className="fa fa-info text-blue opacity-3" ></i></div>

                    }
                        {data.user_type == 'T' && <div className="btn btn-sm" onClick={() => this.edit(data)}><i className="fa fa-edit text-blue " ></i></div>}

                    </td>
                </tr>
                {this.state.open &&
                    (data.address.length > 0) && data.address.map((item, index) => {
                        // console.log('item ',item);
                        return (
                            <tr key={index} style={{ backgroundColor: 'rgb(231, 231, 231)' }}>

                                <td colSpan={3}>
                                    Address     : {index + 1} <br />
                                    Location    : {item.location} <br />
                                    Street      : {item.streat} <br />
                                    Land mark   : {item.land_mark} <br />
                                    Building no : {item.building_no} <br />
                                    Door no     : {item.door_no} <br />
                                </td>
                                <td colSpan={4}>
                                    <div>
                                        <iframe width={300} height={170} frameBorder={0} scrolling="no" marginHeight={0} marginWidth={0} src={`https://maps.google.com/maps?q=` + item.latitude + `,` + item.longitude + `&hl=en&z=14&output=embed`}>
                                        </iframe>
                                        <br />
                                    </div>
                                </td>
                            </tr>
                        )
                    })

                }

            </>
        )
    }
}

